// // import React, { useState, useEffect } from "react";
// // import { ChevronLeft, ChevronRight, X } from "lucide-react";
// // import { BASE_URL } from "../../../services/configUrls";

// // const ElegantCarousel = ({ onClose }) => {
// //   const [currentSlide, setCurrentSlide] = useState(0);
// //   const [isAnimating, setIsAnimating] = useState(false);
// //   const [slides, setSlides] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   // Fetch posters from API
// //   useEffect(() => {
// //     const fetchPosters = async () => {
// //       try {
// //         setLoading(true);
// //         const response = await fetch(`${BASE_URL}/documents/usertypePosters`, {
// //           method: "POST",
// //           headers: {
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify({ usertype: "institute" }),
// //         });

// //         if (!response.ok) {
// //           throw new Error("Failed to fetch posters");
// //         }

// //         const data = await response.json();

// //         // Transform API data to slides format
// //         const transformedSlides = data.map((poster) => ({
// //           image: poster.imageurl,
// //           title: poster.heading,
// //           description: poster.description,
// //           tag: "Poster",
// //           posterid: poster.posterid,
// //         }));

// //         setSlides(transformedSlides);
// //         setLoading(false);
// //       } catch (err) {
// //         setError(err.message);
// //         setLoading(false);
// //       }
// //     };

// //     fetchPosters();
// //   }, []);

  
// //   const isLastSlide = currentSlide === slides.length - 1;

// //   const nextSlide = () => {
// //     if (isAnimating || isLastSlide) return;
// //     setIsAnimating(true);
// //     setCurrentSlide((prev) => prev + 1);
// //     setTimeout(() => setIsAnimating(false), 500);
// //   };

// //   const prevSlide = () => {
// //     if (isAnimating || currentSlide === 0) return;
// //     setIsAnimating(true);
// //     setCurrentSlide((prev) => prev - 1);
// //     setTimeout(() => setIsAnimating(false), 500);
// //   };

// //   const handleExit = () => {
// //     // Set cookie when user exits
// //     document.cookie = "carouselViewed=true; max-age=31536000; path=/";
// //     onClose();
// //   };

// //   // Prevent body scroll when modal is open
// //   useEffect(() => {
// //     document.body.style.overflow = "hidden";
// //     return () => {
// //       document.body.style.overflow = "unset";
// //     };
// //   }, []);

// //   useEffect(() => {
// //     const handleKeyDown = (e) => {
// //       if (e.key === "ArrowLeft") prevSlide();
// //       if (e.key === "ArrowRight") nextSlide();
// //       if (e.key === "Escape") handleExit();
// //     };

// //     window.addEventListener("keydown", handleKeyDown);
// //     return () => window.removeEventListener("keydown", handleKeyDown);
// //   }, [isAnimating, currentSlide, isLastSlide]);

// //   if (!loading && slides.length === 0) {
// //   return null;
// // }
// //   // Loading state with skeleton
// //   if (loading) {
// //     return (
// //       <>
// //         <div
// //           className="fixed inset-0 bg-black/90 backdrop-blur-sm"
// //           style={{ zIndex: 9998 }}
// //         ></div>
// //         <div
// //           className="fixed inset-0 flex items-center justify-center p-4 md:p-8"
// //           style={{ zIndex: 9999 }}
// //         >
// //           <div className="relative w-full max-w-6xl h-[85vh] mx-auto">
// //             <div className="relative h-full rounded-2xl overflow-hidden shadow-2xl bg-gray-800/50 backdrop-blur-md">
// //               {/* Skeleton Animation */}
// //               <div className="absolute inset-0 animate-pulse">
// //                 <div className="w-full h-full bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800"></div>
// //               </div>

// //               {/* Skeleton Content Elements */}
// //               <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
// //                 <div className="space-y-4 animate-pulse">
// //                   <div className="h-6 w-24 bg-gray-700 rounded-full"></div>
// //                   <div className="h-8 w-3/4 bg-gray-700 rounded"></div>
// //                   <div className="h-6 w-1/2 bg-gray-700 rounded"></div>
// //                 </div>
// //               </div>

// //               {/* Skeleton Counter */}
// //               <div className="absolute top-4 md:top-6 left-4 md:left-6 px-4 py-2 bg-gray-700 rounded-full animate-pulse">
// //                 <div className="h-4 w-12"></div>
// //               </div>

// //               {/* Skeleton Progress Dots */}
// //               <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
// //                 {[1, 2, 3].map((i) => (
// //                   <div
// //                     key={i}
// //                     className="h-1 w-8 bg-gray-700 rounded-full animate-pulse"
// //                   ></div>
// //                 ))}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </>
// //     );
// //   }

// //   // Error state
// //   if (error) {
// //     return (
// //       <>
// //         <div
// //           className="fixed inset-0 bg-black/90 backdrop-blur-sm animate-fadeIn"
// //           style={{ zIndex: 9998 }}
// //         ></div>
// //         <div
// //           className="fixed inset-0 flex items-center justify-center p-4"
// //           style={{ zIndex: 9999 }}
// //         >
// //           <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 max-w-md">
// //             {/* Exit Button */}
// //             <button
// //               onClick={handleExit}
// //               className="absolute top-4 right-4 p-3 bg-red-500/90 hover:bg-red-600 rounded-full transition-all duration-300 group shadow-lg"
// //               aria-label="Exit"
// //             >
// //               <X className="w-5 h-5 text-white group-hover:rotate-90 transition-transform duration-300" />
// //             </button>

// //             <div className="text-center">
// //               <div className="text-red-400 text-6xl mb-4">⚠️</div>
// //               <h3 className="text-white text-2xl font-bold mb-2">Oops!</h3>
// //               <p className="text-gray-300 text-lg mb-6">
// //                 Unable to load posters. Please try again later.
// //               </p>
// //               <p className="text-gray-400 text-sm">{error}</p>
// //             </div>
// //           </div>
// //         </div>
// //         <style jsx>{`
// //           @keyframes fadeIn {
// //             from {
// //               opacity: 0;
// //             }
// //             to {
// //               opacity: 1;
// //             }
// //           }

// //           .animate-fadeIn {
// //             animation: fadeIn 0.4s ease-in-out;
// //           }
// //         `}</style>
// //       </>
// //     );
// //   }

// //   // No slides available
// //   // if (slides.length === 0) {
// //   //   return (
// //   //     <>
// //   //       <div
// //   //         className="fixed inset-0 bg-black/90 backdrop-blur-sm animate-fadeIn"
// //   //         style={{ zIndex: 9998 }}
// //   //       ></div>
// //   //       <div
// //   //         className="fixed inset-0 flex items-center justify-center p-4"
// //   //         style={{ zIndex: 9999 }}
// //   //       >
// //   //         <div className="relative bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 max-w-md">
// //   //           {/* Exit Button */}
// //   //           <button
// //   //             onClick={handleExit}
// //   //             className="absolute top-4 right-4 p-3 bg-red-500/90 hover:bg-red-600 rounded-full transition-all duration-300 group shadow-lg"
// //   //             aria-label="Exit"
// //   //           >
// //   //             <X className="w-5 h-5 text-white group-hover:rotate-90 transition-transform duration-300" />
// //   //           </button>

// //   //           <div className="text-center">
// //   //             <div className="text-gray-400 text-6xl mb-4">📭</div>
// //   //             <h3 className="text-white text-2xl font-bold mb-2">
// //   //               No Posters Available
// //   //             </h3>
// //   //             <p className="text-gray-300 text-lg">
// //   //               There are no posters to display at the moment.
// //   //             </p>
// //   //           </div>
// //   //         </div>
// //   //       </div>
// //   //       <style jsx>{`
// //   //         @keyframes fadeIn {
// //   //           from {
// //   //             opacity: 0;
// //   //           }
// //   //           to {
// //   //             opacity: 1;
// //   //           }
// //   //         }

// //   //         .animate-fadeIn {
// //   //           animation: fadeIn 0.4s ease-in-out;
// //   //         }
// //   //       `}</style>
// //   //     </>
// //   //   );
// //   // }

// //   return (
// //     <>
// //       {/* Modal Backdrop */}
// //       <div
// //         className="fixed inset-0 bg-black/90 backdrop-blur-sm animate-fadeIn"
// //         style={{ zIndex: 9998 }}
// //       ></div>

// //       {/* Modal Content */}
// //       <div
// //         className="fixed inset-0 flex items-center justify-center p-4 md:p-8 animate-fadeIn"
// //         style={{ zIndex: 9999 }}
// //       >
// //         <div className="relative w-full max-w-6xl h-[85vh] mx-auto">
// //           {/* Main Image Container */}
// //           <div className="relative h-full rounded-2xl overflow-hidden shadow-2xl bg-black">
// //             {/* Slides */}
// //             {slides.map((slide, index) => (
// //               <div
// //                 key={slide.posterid}
// //                 className={`absolute inset-0 transition-all duration-700 ease-in-out flex items-center justify-center ${
// //                   index === currentSlide
// //                     ? "opacity-100 scale-100"
// //                     : "opacity-0 scale-105"
// //                 }`}
// //               >
// //                 {/* Image with Dynamic Sizing - Contains within box */}
// //                 <img
// //                   src={slide.image}
// //                   alt={slide.title}
// //                   className="max-w-full max-h-full w-auto h-auto object-contain"
// //                   loading={index === 0 ? "eager" : "lazy"}
// //                   decoding="async"
// //                 />

// //                 {/* Gradient Overlay */}
// //                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none"></div>

// //                 {/* Text Content */}
// //                 <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-white pointer-events-none">
// //                   <div
// //                     className={`transform transition-all duration-700 delay-150 ${
// //                       index === currentSlide
// //                         ? "translate-y-0 opacity-100"
// //                         : "translate-y-8 opacity-0"
// //                     }`}
// //                   >
// //                     {/* <span className="inline-block px-4 py-1 bg-white/20 backdrop-blur-md rounded-full text-sm font-medium mb-4">
// //                       {slide.tag}
// //                     </span> */}
// //                     <p className="text-lg md:text-xl text-gray-200 max-w-2xl">
// //                       {slide.description}
// //                     </p>
// //                   </div>
// //                 </div>
// //               </div>
// //             ))}

// //             {/* Navigation Arrows */}
// //             <button
// //               onClick={prevSlide}
// //               disabled={isAnimating || currentSlide === 0}
// //               className="absolute left-4 md:left-6 top-1/2 -translate-y-1/2 p-3 md:p-4 bg-white/10 hover:bg-white/20 rounded-full backdrop-blur-md transition-all duration-300 disabled:opacity-30 disabled:cursor-not-allowed group z-10"
// //               aria-label="Previous slide"
// //             >
// //               <ChevronLeft className="w-5 h-5 md:w-6 md:h-6 text-white group-hover:-translate-x-1 transition-transform duration-300" />
// //             </button>

// //             {/* Next Button - Bottom Right Corner */}
// //             <button
// //               onClick={nextSlide}
// //               disabled={isAnimating || isLastSlide}
// //               className="absolute right-4 md:right-6 bottom-4 md:bottom-6 p-3 md:p-4 bg-blue-500/90 hover:bg-blue-600 rounded-full backdrop-blur-md transition-all duration-300 disabled:opacity-30 disabled:cursor-not-allowed group shadow-lg z-10"
// //               aria-label="Next slide"
// //             >
// //               <ChevronRight className="w-5 h-5 md:w-6 md:h-6 text-white group-hover:translate-x-1 transition-transform duration-300" />
// //             </button>

// //             {/* Slide Counter */}
// //             <div className="absolute top-4 md:top-6 left-4 md:left-6 px-3 md:px-4 py-2 bg-white/10 backdrop-blur-md rounded-full text-white font-medium text-sm md:text-base z-10">
// //               {currentSlide + 1} / {slides.length}
// //             </div>

// //             {/* Exit Button - Bottom Right Corner (Only on Last Slide) */}
// //             {isLastSlide && (
// //               <button
// //                 onClick={handleExit}
// //                 className="absolute right-4 md:right-6 bottom-4 md:bottom-6 p-3 md:p-4 bg-red-500/90 hover:bg-red-600 rounded-full backdrop-blur-md transition-all duration-300 group shadow-lg animate-fadeIn z-10"
// //                 aria-label="Exit gallery"
// //               >
// //                 <X className="w-5 h-5 md:w-6 md:h-6 text-white group-hover:rotate-90 transition-transform duration-300" />
// //               </button>
// //             )}

// //             {/* Progress Indicator */}
// //             <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
// //               {slides.map((_, index) => (
// //                 <div
// //                   key={index}
// //                   className={`h-1 rounded-full transition-all duration-300 ${
// //                     index === currentSlide ? "w-8 bg-white" : "w-1 bg-white/50"
// //                   }`}
// //                 ></div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <style jsx>{`
// //         @keyframes fadeIn {
// //           from {
// //             opacity: 0;
// //           }
// //           to {
// //             opacity: 1;
// //           }
// //         }

// //         .animate-fadeIn {
// //           animation: fadeIn 0.4s ease-in-out;
// //         }
// //       `}</style>
// //     </>
// //   );
// // };

// // export default ElegantCarousel;

// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogContent,
//   Box,
//   IconButton,
//   Typography,
//   useTheme,
//   useMediaQuery,
//   Button,
//   CircularProgress,
//   Tooltip,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import { BASE_URL } from "../../../services/configUrls";

// const ElegantCarousel = ({ onClose }) => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [slides, setSlides] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [hoveredLink, setHoveredLink] = useState(null);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   // Further reduced canvas dimensions
//   const CANVAS_WIDTH = 320;
//   const CANVAS_HEIGHT = 400;

//   // Fetch posters from API - ORIGINAL LOGIC
//   useEffect(() => {
//     const fetchPosters = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${BASE_URL}/documents/usertypePosters`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ usertype: "institute" }),
//         });

//         if (!response.ok) {
//           throw new Error("Failed to fetch posters");
//         }

//         const data = await response.json();

//         // Transform API data to slides format with link parsing
//         const transformedSlides = data.map((poster) => {
//           let linkData = null;
//           if (poster.description) {
//             try {
//               linkData = typeof poster.description === 'string' 
//                 ? JSON.parse(poster.description) 
//                 : poster.description;
//             } catch (e) {
//               console.error("Failed to parse description:", e);
//               linkData = null;
//             }
//           }

//           return {
//             image: poster.imageurl,
//             title: poster.heading,
//             description: poster.description,
//             tag: "Poster",
//             posterid: poster.posterid,
//             linkData: linkData,
//           };
//         });

//         setSlides(transformedSlides);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchPosters();
//   }, []);

//   // ORIGINAL SLIDE NAVIGATION LOGIC
//   const isLastSlide = currentSlide === slides.length - 1;

//   const nextSlide = () => {
//     if (isAnimating || isLastSlide) return;
//     setIsAnimating(true);
//     setCurrentSlide((prev) => prev + 1);
//     setTimeout(() => setIsAnimating(false), 500);
//   };

//   const prevSlide = () => {
//     if (isAnimating || currentSlide === 0) return;
//     setIsAnimating(true);
//     setCurrentSlide((prev) => prev - 1);
//     setTimeout(() => setIsAnimating(false), 500);
//   };

//   const handleExit = () => {
//     // Set cookie when user exits - ORIGINAL LOGIC
//     document.cookie = "carouselViewed=true; max-age=31536000; path=/";
//     onClose();
//   };

//   // Auto-advance slides
//   useEffect(() => {
//     if (slides.length > 1) {
//       const autoAdvanceTimer = setTimeout(() => {
//         if (!isLastSlide) {
//           nextSlide();
//         }
//       }, 4000);

//       return () => clearTimeout(autoAdvanceTimer);
//     }
//   }, [currentSlide, slides.length, isLastSlide]);

//   // Prevent body scroll when modal is open - ORIGINAL LOGIC
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, []);

//   // Keyboard navigation - ORIGINAL LOGIC
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "ArrowLeft") prevSlide();
//       if (e.key === "ArrowRight") nextSlide();
//       if (e.key === "Escape") handleExit();
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [isAnimating, currentSlide, isLastSlide]);

//   // Handle link click
//   const handleLinkClick = (e, link) => {
//     e.preventDefault();
//     e.stopPropagation();
//     console.log("Opening link:", link.url);
//     window.open(link.url, "_blank", "noopener,noreferrer");
//   };

//   // Check if current image has links
//   const hasLinks = (image) => {
//     return (
//       image.linkData &&
//       Array.isArray(image.linkData) &&
//       image.linkData.length > 0
//     );
//   };

//   const handleDotClick = (index) => {
//     setCurrentSlide(index);
//   };

//   const handleDialogClose = (event, reason) => {
//     if (reason === "backdropClick" || reason === "escapeKeyDown") {
//       return;
//     }
//     handleExit();
//   };

//   // Don't show anything if no slides available - ORIGINAL LOGIC
//   if (!loading && slides.length === 0) {
//     return null;
//   }

//   // Loading state
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           zIndex: 9999,
//           backgroundColor: "rgba(0, 0, 0, 0.5)",
//         }}
//       >
//         <CircularProgress size={40} color="primary" />
//       </Box>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <Dialog
//         open={true}
//         onClose={handleDialogClose}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             backgroundColor: "#000",
//             maxWidth: 300,
//             margin: '20px',
//           },
//         }}
//       >
//         <DialogContent sx={{ padding: 2, textAlign: "center" }}>
//           <Box sx={{ position: "relative" }}>
//             <Button
//               onClick={handleExit}
//               startIcon={<CloseIcon />}
//               variant="contained"
//               sx={{
//                 position: "absolute",
//                 top: -10,
//                 right: -10,
//                 backgroundColor: "#0A507D",
//                 color: "white",
//                 minWidth: 'auto',
//                 padding: '4px 8px',
//                 fontSize: '0.7rem',
//                 "&:hover": {
//                   backgroundColor: "#084068",
//                 },
//               }}
//             >
//               Close
//             </Button>
            
//             <Typography variant="h4" sx={{ color: "white", mb: 1, fontSize: '2rem' }}>
//               ⚠️
//             </Typography>
//             <Typography variant="h6" sx={{ color: "white", mb: 1, fontSize: '1rem' }}>
//               Oops!
//             </Typography>
//             <Typography variant="body1" sx={{ color: "gray.300", mb: 1, fontSize: '0.8rem' }}>
//               Unable to load posters.
//             </Typography>
//             <Typography variant="caption" sx={{ color: "gray.400", fontSize: '0.7rem' }}>
//               {error}
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     );
//   }

//   const currentImage = slides[currentSlide];
//   const canNavigate = slides.length > 1;

//   return (
//     <Dialog
//       open={true}
//       onClose={handleDialogClose}
//       maxWidth="sm"
//       fullWidth
//       fullScreen={isMobile}
//       disableEscapeKeyDown
//       PaperProps={{
//         sx: {
//           borderRadius: 0,
//           minHeight: isMobile ? "100vh" : 400,
//           maxHeight: isMobile ? "100vh" : 400,
//           width: isMobile ? "100%" : 320,
//           maxWidth: isMobile ? "100%" : 320,
//           backgroundColor: "#000",
//           overflow: "hidden",
//           boxShadow: 'none',
//           border: 'none',
//         },
//       }}
//     >
//       <DialogContent
//         sx={{
//           padding: 0,
//           position: "relative",
//           overflow: "hidden",
//           height: "100%",
//           '&:first-of-type': {
//             padding: 0,
//           },
//         }}
//       >
//         {/* Close button only on last slide */}
//         {isLastSlide && (
//           <Button
//             onClick={handleExit}
//             // startIcon={<CloseIcon />}
//             variant="contained"
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               zIndex: 10,
//               backgroundColor: "#0A507D",
//               color: "white",
//               minWidth: 'auto',
//               padding: '4px 8px',
//               fontSize: '0.7rem',
//               "&:hover": {
//                 backgroundColor: "#084068",
//               },
//               transition: "all 0.3s ease",
//               borderRadius: 1,
//             }}
//           >
//             {/* Close */} <CloseIcon />
//           </Button>
//         )}

//         {/* Main Image Container */}
//         <Box
//           sx={{
//             position: "relative",
//             height: "100%",
//             minHeight: isMobile ? "100vh" : 400,
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             backgroundColor: "#f5f5f5",
//           }}
//         >
//           {/* Background Image */}
//           <Box
//             component="img"
//             src={currentImage.image}
//             alt={currentImage.title}
//             loading="eager"
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               objectPosition: "center",
//               position: "absolute",
//               top: 0,
//               left: 0,
//               zIndex: 1,
//               transition: "opacity 0.5s ease-in-out",
//             }}
//           />

//           {/* Clickable Link Overlays */}
//           {hasLinks(currentImage) &&
//             currentImage.linkData.map((link, index) => {
//               const x = link.x || 0;
//               const y = link.y || 0;
//               const width = link.width || 0;
//               const height = link.height || 0;

//               // Convert canvas pixel coordinates to percentages
//               const leftPercent = (x / CANVAS_WIDTH) * 100;
//               const topPercent = (y / CANVAS_HEIGHT) * 100;
//               const widthPercent = (width / CANVAS_WIDTH) * 100;
//               const heightPercent = (height / CANVAS_HEIGHT) * 100;

//               return (
//                 <Tooltip
//                   key={index}
//                   title={
//                     <Box sx={{ textAlign: "center" }}>
//                       <Typography variant="caption" display="block" fontWeight="bold">
//                         {link.text}
//                       </Typography>
//                       <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
//                         🔗 {link.url}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <Box
//                     component="a"
//                     href={link.url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     onClick={(e) => handleLinkClick(e, link)}
//                     onMouseEnter={() => setHoveredLink(`${currentImage.posterid}-${index}`)}
//                     onMouseLeave={() => setHoveredLink(null)}
//                     sx={{
//                       position: "absolute",
//                       left: `${leftPercent}%`,
//                       top: `${topPercent}%`,
//                       width: `${widthPercent}%`,
//                       height: `${heightPercent}%`,
//                       cursor: "pointer",
//                       zIndex: 5,
//                       border: "none",
//                       backgroundColor:
//                         hoveredLink === `${currentImage.posterid}-${index}`
//                           ? "rgba(25, 118, 210, 0.3)"
//                           : "rgba(25, 118, 210, 0.1)",
//                       transition: "all 0.2s ease",
//                       "&:hover": {
//                         backgroundColor: "rgba(25, 118, 210, 0.4)",
//                       },
//                     }}
//                     aria-label={`Link: ${link.text} - ${link.url}`}
//                   />
//                 </Tooltip>
//               );
//             })}

//           {/* Clean Bottom Overlay */}
//           <Box
//             sx={{
//               position: "absolute",
//               bottom: 0,
//               left: 0,
//               right: 0,
//               background: "rgba(0, 0, 0, 0.4)",
//               zIndex: 2,
//               height: 60,
//             }}
//           />

//           {/* Navigation Arrows (Desktop/Tablet) */}
//           {!isMobile && canNavigate && (
//             <>
//               <IconButton
//                 onClick={prevSlide}
//                 disabled={isAnimating || currentSlide === 0}
//                 sx={{
//                   position: "absolute",
//                   left: 8,
//                   zIndex: 6,
//                   backgroundColor: "#0A507D",
//                   color: "white",
//                   width: 32,
//                   height: 32,
//                   "&:hover": {
//                     backgroundColor: "#084068",
//                   },
//                   "&:disabled": {
//                     opacity: 0.3,
//                     cursor: "not-allowed",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 <ArrowBackIosIcon fontSize="small" />
//               </IconButton>

//               <IconButton
//                 onClick={nextSlide}
//                 disabled={isAnimating || isLastSlide}
//                 sx={{
//                   position: "absolute",
//                   right: 8,
//                   zIndex: 6,
//                   backgroundColor: "#0A507D",
//                   color: "white",
//                   width: 32,
//                   height: 32,
//                   "&:hover": {
//                     backgroundColor: "#084068",
//                   },
//                   "&:disabled": {
//                     opacity: 0.3,
//                     cursor: "not-allowed",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 <ArrowForwardIosIcon fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {/* Content Overlay */}
//           <Box
//             sx={{
//               position: "absolute",
//               bottom: 0,
//               left: 0,
//               right: 0,
//               padding: "12px",
//               zIndex: 3,
//               textAlign: "center",
//               color: "white",
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 flexDirection: { xs: "column", md: "row" },
//                 gap: { xs: 1.5, md: 0 },
//               }}
//             >
//               {isMobile && canNavigate && (
//                 <Box sx={{ display: "flex", gap: 1, order: { xs: 2, md: 1 } }}>
//                   <IconButton
//                     onClick={prevSlide}
//                     disabled={isAnimating || currentSlide === 0}
//                     sx={{
//                       backgroundColor: "#0A507D",
//                       color: "white",
//                       width: 32,
//                       height: 32,
//                       "&:hover": {
//                         backgroundColor: "#084068",
//                       },
//                       "&:disabled": {
//                         opacity: 0.3,
//                         cursor: "not-allowed",
//                       },
//                     }}
//                   >
//                     <ArrowBackIosIcon fontSize="small" />
//                   </IconButton>

//                   <IconButton
//                     onClick={nextSlide}
//                     disabled={isAnimating || isLastSlide}
//                     sx={{
//                       backgroundColor: "#0A507D",
//                       color: "white",
//                       width: 32,
//                       height: 32,
//                       "&:hover": {
//                         backgroundColor: "#084068",
//                       },
//                       "&:disabled": {
//                         opacity: 0.3,
//                         cursor: "not-allowed",
//                       },
//                     }}
//                   >
//                     <ArrowForwardIosIcon fontSize="small" />
//                   </IconButton>
//                 </Box>
//               )}

//               {/* Progress Dots */}
//               {canNavigate && (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     gap: 0.5,
//                     justifyContent: "center",
//                     order: { xs: 1, md: 2 },
//                   }}
//                 >
//                   {slides.map((_, index) => (
//                     <Box
//                       key={index}
//                       sx={{
//                         width: 6,
//                         height: 6,
//                         borderRadius: "50%",
//                         backgroundColor:
//                           index === currentSlide
//                             ? "#0A507D"
//                             : "rgba(255, 255, 255, 0.5)",
//                         cursor: "pointer",
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           backgroundColor: 
//                             index === currentSlide 
//                               ? "#0A507D" 
//                               : "rgba(255, 255, 255, 0.8)",
//                         },
//                       }}
//                       onClick={() => handleDotClick(index)}
//                     />
//                   ))}
//                 </Box>
//               )}

//               {/* Page Count */}
//               <Box sx={{ order: { xs: 3, md: 3 } }}>
//                 <Box
//                   sx={{
//                     padding: "4px 8px",
//                     backgroundColor: "#0A507D",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "white",
//                       fontWeight: 500,
//                       fontSize: "0.7rem",
//                     }}
//                   >
//                     {currentSlide + 1} of {slides.length}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default ElegantCarousel;

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  CircularProgress,
  Tooltip,
  Backdrop,
  Zoom,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { BASE_URL } from "../../../services/configUrls";

const ElegantCarousel = ({ onClose }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredLink, setHoveredLink] = useState(null);
  
  // Fullscreen image viewer states
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [fullscreenImageUrl, setFullscreenImageUrl] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Canvas dimensions matching WelcomePopup
  const CANVAS_WIDTH = 450;
  const CANVAS_HEIGHT = 600;

  // Fetch posters from API
  useEffect(() => {
    const fetchPosters = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/documents/usertypePosters`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ usertype: "institute" }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch posters");
        }

        const data = await response.json();

        // Transform API data to slides format with link parsing
        const transformedSlides = data.map((poster) => {
          let linkData = null;
          if (poster.description) {
            try {
              linkData = typeof poster.description === 'string' 
                ? JSON.parse(poster.description) 
                : poster.description;
            } catch (e) {
              console.error("Failed to parse description:", e);
              linkData = null;
            }
          }

          return {
            image: poster.imageurl,
            title: poster.heading,
            description: poster.description,
            tag: "Poster",
            posterid: poster.posterid,
            linkData: linkData,
          };
        });

        setSlides(transformedSlides);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPosters();
  }, []);

  const isLastSlide = currentSlide === slides.length - 1;

  const nextSlide = () => {
    if (isAnimating || isLastSlide) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => prev + 1);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const prevSlide = () => {
    if (isAnimating || currentSlide === 0) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => prev - 1);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const handleExit = () => {
    document.cookie = "carouselViewed=true; max-age=31536000; path=/";
    onClose();
  };

  // Handle image click for fullscreen view
  const handleImageClick = (e) => {
    if (e.target.tagName === "A" || e.target.closest("a")) {
      return;
    }
    setFullscreenImageUrl(currentImage.image);
    setFullscreenOpen(true);
  };

  // Handle fullscreen close
  const handleFullscreenClose = () => {
    setFullscreenOpen(false);
    setFullscreenImageUrl("");
  };

  // Auto-advance slides
  useEffect(() => {
    if (slides.length > 1 && !fullscreenOpen) {
      const autoAdvanceTimer = setTimeout(() => {
        if (!isLastSlide) {
          nextSlide();
        }
      }, 4000);

      return () => clearTimeout(autoAdvanceTimer);
    }
  }, [currentSlide, slides.length, isLastSlide, fullscreenOpen]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "Escape") {
        if (fullscreenOpen) {
          handleFullscreenClose();
        } else {
          handleExit();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isAnimating, currentSlide, isLastSlide, fullscreenOpen]);

  // Handle link click
  const handleLinkClick = (e, link) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(link.url, "_blank", "noopener,noreferrer");
  };

  // Check if current image has links
  const hasLinks = (image) => {
    return (
      image.linkData &&
      Array.isArray(image.linkData) &&
      image.linkData.length > 0
    );
  };

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    handleExit();
  };

  // Don't show anything if no slides available
  if (!loading && slides.length === 0) {
    return null;
  }

  // Loading state
  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <CircularProgress size={40} color="primary" />
      </Box>
    );
  }

  // Error state
  if (error) {
    return (
      <Dialog
        open={true}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#000",
            maxWidth: 600,
            margin: '20px',
          },
        }}
      >
        <DialogContent sx={{ padding: 3, textAlign: "center" }}>
          <Box sx={{ position: "relative" }}>
            <Button
              onClick={handleExit}
              startIcon={<CloseIcon />}
              variant="contained"
              sx={{
                position: "absolute",
                top: -15,
                right: -15,
                backgroundColor: "#0A507D",
                color: "white",
                minWidth: 'auto',
                padding: '8px 16px',
                "&:hover": {
                  backgroundColor: "#084068",
                },
              }}
            >
              Close
            </Button>
            
            <Typography variant="h4" sx={{ color: "white", mb: 2 }}>
              ⚠️
            </Typography>
            <Typography variant="h5" sx={{ color: "white", mb: 2 }}>
              Oops!
            </Typography>
            <Typography variant="body1" sx={{ color: "gray.300", mb: 2 }}>
              Unable to load posters.
            </Typography>
            <Typography variant="caption" sx={{ color: "gray.400" }}>
              {error}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  const currentImage = slides[currentSlide];
  const canNavigate = slides.length > 1;

  return (
    <>
      {/* Main Carousel Dialog - Fixed sizing */}
      <Dialog
        open={true}
        onClose={handleDialogClose}
        maxWidth={false}
        fullWidth={false}
        fullScreen={isMobile}
        disableEscapeKeyDown
        sx={{
          '& .MuiDialog-container': {
            alignItems: isMobile ? 'stretch' : 'center',
            justifyContent: isMobile ? 'stretch' : 'center',
          },
          '& .MuiDialog-paper': {
            margin: isMobile ? 0 : '32px',
            width: isMobile ? '100%' : '450px',
            height: isMobile ? '100%' : '600px',
            maxWidth: isMobile ? '100%' : '450px',
            maxHeight: isMobile ? '100%' : '600px',
            minWidth: isMobile ? '100%' : '450px',
            minHeight: isMobile ? '100%' : '600px',
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 3,
            backgroundColor: "#000",
            overflow: "hidden",
            // Ensure exact dimensions
            width: '450px',
            height: '600px',
            maxWidth: '450px',
            maxHeight: '600px',
            minWidth: '450px',
            minHeight: '600px',
            display: 'flex',
            flexDirection: 'column',
            ...(isMobile && {
              width: '100%',
              height: '100%',
              maxWidth: '100%',
              maxHeight: '100%',
              minWidth: '100%',
              minHeight: '100%',
              borderRadius: 0,
            }),
          },
        }}
      >
        <DialogContent
          sx={{
            padding: 0,
            position: "relative",
            overflow: "hidden",
            height: "100%",
            width: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Close button only on last slide */}
          {isLastSlide && (
            <Button
              onClick={handleExit}
              startIcon={<CloseIcon />}
              variant="contained"
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                zIndex: 10,
                backgroundColor: "#0A507D",
                color: "white",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#084068",
                  transform: "scale(1.05)",
                },
                transition: "all 0.3s ease",
                borderRadius: 2,
                padding: '8px 16px',
              }}
            >
              Close
            </Button>
          )}

          {/* Zoom/View Fullscreen Button */}
          <Tooltip title="View Fullscreen" placement="left">
            <IconButton
              onClick={handleImageClick}
              sx={{
                position: "absolute",
                top: 16,
                left: 16,
                zIndex: 10,
                backgroundColor: "rgba(10, 80, 125, 0.9)",
                color: "white",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#084068",
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
                width: 48,
                height: 48,
              }}
            >
              <ZoomInIcon />
            </IconButton>
          </Tooltip>

          {/* Main Image Container */}
          <Box
            sx={{
              position: "relative",
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#000",
              flex: 1,
            }}
          >
            {/* Background Image - Clickable for fullscreen */}
            <Box
              component="img"
              src={currentImage.image}
              alt={currentImage.title}
              loading="eager"
              onClick={handleImageClick}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
                cursor: "zoom-in",
                transition: "opacity 0.5s ease-in-out",
              }}
            />

            {/* Clickable Link Overlays */}
            {hasLinks(currentImage) &&
              currentImage.linkData.map((link, index) => {
                const x = link.x || 0;
                const y = link.y || 0;
                const width = link.width || 0;
                const height = link.height || 0;

                // Convert canvas pixel coordinates to percentages
                const leftPercent = (x / CANVAS_WIDTH) * 100;
                const topPercent = (y / CANVAS_HEIGHT) * 100;
                const widthPercent = (width / CANVAS_WIDTH) * 100;
                const heightPercent = (height / CANVAS_HEIGHT) * 100;

                return (
                  <Tooltip
                    key={index}
                    title={
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" fontWeight="bold">
                          {link.text || 'Click to open link'}
                        </Typography>
                        {link.url && (
                          <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                            🔗 {link.url}
                          </Typography>
                        )}
                      </Box>
                    }
                    arrow
                    placement="top"
                  >
                    <Box
                      component="a"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => handleLinkClick(e, link)}
                      onMouseEnter={() => setHoveredLink(`${currentImage.posterid}-${index}`)}
                      onMouseLeave={() => setHoveredLink(null)}
                      sx={{
                        position: "absolute",
                        left: `${leftPercent}%`,
                        top: `${topPercent}%`,
                        width: `${widthPercent}%`,
                        height: `${heightPercent}%`,
                        cursor: "pointer",
                        zIndex: 5,
                        border:
                          hoveredLink === `${currentImage.posterid}-${index}`
                            ? "2px solid #1976d2"
                            : "2px solid transparent",
                        backgroundColor:
                          hoveredLink === `${currentImage.posterid}-${index}`
                            ? "rgba(25, 118, 210, 0.3)"
                            : "rgba(25, 118, 210, 0.1)",
                        transition: "all 0.2s ease",
                        borderRadius: "4px",
                        "&:hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.4)",
                          transform: "scale(1.02)",
                        },
                      }}
                      aria-label={`Link: ${link.text || link.url}`}
                    />
                  </Tooltip>
                );
              })}

            {/* Clean Bottom Overlay */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                background: "linear-gradient(transparent 0%, rgba(0,0,0,0.6) 100%)",
                zIndex: 2,
                height: 120,
              }}
            />

            {/* Navigation Arrows (Desktop/Tablet) */}
            {!isMobile && canNavigate && (
              <>
                <IconButton
                  onClick={prevSlide}
                  disabled={isAnimating || currentSlide === 0}
                  sx={{
                    position: "absolute",
                    left: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 6,
                    backgroundColor: "#0A507D",
                    color: "white",
                    width: 48,
                    height: 48,
                    boxShadow: 2,
                    "&:hover": {
                      backgroundColor: "#084068",
                      transform: "translateY(-50%) scale(1.1)",
                    },
                    "&:disabled": {
                      opacity: 0.3,
                      cursor: "not-allowed",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  <ArrowBackIosIcon />
                </IconButton>

                <IconButton
                  onClick={nextSlide}
                  disabled={isAnimating || isLastSlide}
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 6,
                    backgroundColor: "#0A507D",
                    color: "white",
                    width: 48,
                    height: 48,
                    boxShadow: 2,
                    "&:hover": {
                      backgroundColor: "#084068",
                      transform: "translateY(-50%) scale(1.1)",
                    },
                    "&:disabled": {
                      opacity: 0.3,
                      cursor: "not-allowed",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  <ArrowForwardIosIcon />
                </IconButton>
              </>
            )}

            {/* Content Overlay */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                padding: 3,
                zIndex: 3,
                textAlign: "center",
                color: "white",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                  gap: { xs: 2, md: 0 },
                }}
              >
                {isMobile && canNavigate && (
                  <Box sx={{ display: "flex", gap: 2, order: { xs: 2, md: 1 } }}>
                    <IconButton
                      onClick={prevSlide}
                      disabled={isAnimating || currentSlide === 0}
                      sx={{
                        backgroundColor: "#0A507D",
                        color: "white",
                        width: 48,
                        height: 48,
                        "&:hover": {
                          backgroundColor: "#084068",
                        },
                        "&:disabled": {
                          opacity: 0.3,
                          cursor: "not-allowed",
                        },
                        boxShadow: 2,
                      }}
                    >
                      <ArrowBackIosIcon />
                    </IconButton>

                    <IconButton
                      onClick={nextSlide}
                      disabled={isAnimating || isLastSlide}
                      sx={{
                        backgroundColor: "#0A507D",
                        color: "white",
                        width: 48,
                        height: 48,
                        "&:hover": {
                          backgroundColor: "#084068",
                        },
                        "&:disabled": {
                          opacity: 0.3,
                          cursor: "not-allowed",
                        },
                        boxShadow: 2,
                      }}
                    >
                      <ArrowForwardIosIcon />
                    </IconButton>
                  </Box>
                )}

                {/* Progress Dots */}
                {canNavigate && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      justifyContent: "center",
                      order: { xs: 1, md: 2 },
                    }}
                  >
                    {slides.map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor:
                            index === currentSlide
                              ? "#0A507D"
                              : "rgba(255, 255, 255, 0.5)",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: "2px solid rgba(255, 255, 255, 0.3)",
                          "&:hover": {
                            backgroundColor:
                              index === currentSlide
                                ? "#0A507D"
                                : "rgba(255, 255, 255, 0.8)",
                            transform: "scale(1.2)",
                          },
                        }}
                        onClick={() => handleDotClick(index)}
                      />
                    ))}
                  </Box>
                )}

                {/* Page Count */}
                <Box sx={{ order: { xs: 3, md: 3 } }}>
                  <Box
                    sx={{
                      padding: "8px 16px",
                      backgroundColor: "#0A507D",
                      borderRadius: "8px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      boxShadow: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "white",
                        fontWeight: 500,
                      }}
                    >
                      {currentSlide + 1} / {slides.length}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Fullscreen Image Viewer Modal */}
      <Dialog
        open={fullscreenOpen}
        onClose={handleFullscreenClose}
        maxWidth={false}
        fullWidth
        fullScreen
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.95)",
            },
          },
        }}
        sx={{
          zIndex: theme.zIndex.modal + 1,
        }}
      >
        <Zoom in={fullscreenOpen}>
          <DialogContent
            sx={{
              padding: 0,
              position: "relative",
              overflow: "hidden",
              height: "100vh",
              width: "100vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#000",
            }}
          >
            {/* Close Fullscreen Button */}
            <IconButton
              onClick={handleFullscreenClose}
              sx={{
                position: "absolute",
                top: 20,
                right: 20,
                zIndex: 10,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                color: "#000",
                width: 56,
                height: 56,
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#fff",
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>

            {/* Fullscreen Image */}
            <Box
              component="img"
              src={fullscreenImageUrl}
              alt={currentImage.title}
              onClick={handleFullscreenClose}
              sx={{
                maxWidth: "95vw",
                maxHeight: "95vh",
                width: "auto",
                height: "auto",
                objectFit: "contain",
                cursor: "zoom-out",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)",
              }}
            />

            {/* Image Title Overlay */}
            {currentImage.title && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 30,
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  maxWidth: "80%",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    fontWeight: 500,
                  }}
                >
                  {currentImage.title}
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Zoom>
      </Dialog>
    </>
  );
};

export default ElegantCarousel;